import { render, staticRenderFns } from "./WeekActivityStats.vue?vue&type=template&id=42c4eed0&scoped=true&"
import script from "./WeekActivityStats.vue?vue&type=script&lang=js&"
export * from "./WeekActivityStats.vue?vue&type=script&lang=js&"
import style0 from "./WeekActivityStats.vue?vue&type=style&index=0&id=42c4eed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c4eed0",
  null
  
)

export default component.exports